<template>
  <div class="tw-relative tw-flex tw-flex-col tw-gap-[12px]">
    <label v-if="title" class="tw-text-body-bold-mobile apTablet2:tw-text-body-bold-desktop ">{{ title
    }}</label>
    <Dropdown ref="datepickerRef" :manual="true">
      <template #trigger>
        <div class="tw-bg-white apDesktop:tw-rounded-xl tw-rounded-[10px] tw-w-full">
          <input
            type="text"
            :class="[
              'tw-w-full apDesktop:tw-h-16 tw-h-12',
              'tw-outline tw-outline-offset-[-2px] tw-outline-1 tw-outline-ap-gainsboro ',
              'focus:tw-outline-ap-dodger-blue focus:tw-outline-2',
              'apDesktop:tw-rounded-xl tw-rounded-[10px] tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop tw-text-ap-nero ',
              'tw-px-6 tw-py-4',
            // 'dark:tw-text-white dark:tw-outline-ap-night-rider dark:tw-bg-ap-nero '
            ]"
            :placeholder="placeholder"
            :readonly="true"
            :value="dateString"
            :style="[
              backgroundStyle,
              {
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '95% center',
                cursor: 'pointer'
              },]"
            @click="openDatePicker"
          >
        </div>
      </template>
      <div style="display: flex; flex-direction: column;">
        <DatePicker v-model="date" :min-date="minDate" style="border: none;" />
        <span style="cursor: pointer; padding: 8px;" @click="clearDate" @mousedown.prevent>Clear
        </span>
      </div>

    </Dropdown>

    <div class="tw-bg-white tw-rounded-xl" />
    <span
      :class="[
        'tw-absolute tw-bottom-[-24px] tw-left-0 tw-text-red-500 tw-text-base tw-mt-2 tw-z-50',
        'tw-transition-opacity tw-duration-300',
        { '!tw-opacity-0': !errorMsg }
      ]"
    >
      {{ errorMsg }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns';
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import Dropdown from 'v-dropdown';
import { computed, onMounted, ref, watch } from 'vue';
import { cdn } from '../../support/cdn';
import { getDarkMode } from '../../support/helper';

const isDarkMode = ref(false);
const datepickerRef = ref(null);
const date = ref();

function openDatePicker() {
  (datepickerRef.value as any).display();
}

const dateString = computed(() => {
  return date.value ? format(new Date(date.value), 'dd/MM/yyyy') : 'Please select date';
});


const minDate = new Date().toISOString().split('T')[0];
const emit = defineEmits(['update:date', 'selectDate']);
const props = defineProps({
  title: {
    type: String,
    required: false
  },
  date: String,
  placeholder: String,
  errorMsg: {
    type: String,
    required: false, // Mark as optional
    default: null,   // Default value for when the prop is not provided
  },
});

const backgroundStyle = computed(() => ({
  background: `url(${cdn('icons/contact-us/icon_calendar.svg')}) no-repeat 95% center`,}));

onMounted(() => {
  isDarkMode.value = getDarkMode();

  if (props.date) {
    const [day, month, year] = props.date.split('/').map(Number); // Split and convert to numbers
    const parsedDate = new Date(year, month - 1, day); // Create a new Date object (month is 0-based)
    date.value = parsedDate;
  }

  watch(date, (newDate) => {
    if (newDate) {
      setTimeout(() => {
        (datepickerRef.value as any).close();
      }, 200);
      emit('update:date', dateString.value);
      emit('selectDate');
    }
  });
});

function clearDate() {
  date.value = null;
}

</script>